import Environment from '../../Environment';
import stages from '../stages';
import MockSplit from '../../MockSplit';
import { REGION } from '../../../constants';

const prod = new Environment({
    name: stages.PRODUCTION,
    regions: [REGION.BONGARDS, REGION.UDI],
});

const demo = new Environment({
    name: stages.DEMO,
    evaluationFn: (_attributes) => {
        return 'off';
    },
});

const staging = new Environment({
    name: stages.STAGING,
    evaluationFn: (_attributes) => {
        return 'on';
    },
});

const local = new Environment({
    name: stages.LOCAL,
    evaluationFn: (_attributes) => {
        return 'on';
    },
});

const dev = new Environment({
    name: stages.DEV,
    evaluationFn: (_attributes) => {
        return 'on';
    },
});

const enable_producer_profile = new MockSplit({
    name: 'enable_producer_profile',
    environments: [local, dev, staging, demo, prod],
});

export default enable_producer_profile;
